<div id="modalScrollContainer" class="modals__container">
  <div class="modals__header">
    <img mfpLazyImage class="modals__close" lazySrc="assets/icons/close.svg" (click)="close()" />
  </div>
  <div class="complete-form">
    <h1 class="complete-form__title">{{ 'COMPLETE_FORM.TITLE' | translate }}</h1>
    <form
      [formGroup]="completeForm"
      mfpInvalidFormScroll
      [invalidFormScrollOffset]="125"
      invalidFormScrollContainerId="modalScrollContainer"
      (ngSubmit)="save()"
    >
      <div class="complete-form__form">
        <div class="complete-form__box mfp-white-box">
          <ng-container
            *ngIf="
              (type === 'DEATH' || type === 'RETIREMENT') &&
              (!lifePlan.user?.professional?.employmentRelationship ||
                !lifePlan.user?.professional?.employment ||
                (hasSpouse() &&
                  (!lifePlan.spouse?.professional?.employmentRelationship ||
                    !lifePlan.spouse?.professional?.employment ||
                    !lifePlan.spouse?.professional?.contributionYears)))
            "
          >
            <div class="professional-form">
              <h2 class="agent-form__title">{{ 'COMPLETE_FORM.PROFESSIONAL.TITLE' | translate }}</h2>
              <ng-container
                *ngIf="
                  !lifePlan.user?.professional?.employmentRelationship ||
                  !lifePlan.user?.professional?.employment
                "
              >
                <div class="agent-form__section"></div>
                <h3 class="agent-form__subtitle">
                  {{ 'COMPLETE_FORM.PROFESSIONAL.PROFESSIONALS_USER.TITLE' | translate: { username: getUsername() } }}
                </h3>
                <ng-container *ngIf="!lifePlan.user?.professional?.employmentRelationship">
                  <div class="row">
                    <div class="col-xs-24 col-sm-12 col-no-gutter">
                      <mfp-select
                        formControlName="employmentRelationshipClient"
                        view="agent"
                        color="primary"
                        name="employmentRelationshipClient"
                        [label]="'COMPLETE_FORM.PROFESSIONAL.PROFESSIONALS_USER.EMPLOYMENT_RELATIONSHIP' | translate"
                        [placeholder]="'FORMS.SELECT_PLACEHOLDER' | translate"
                        [options]="employmentRelationship"
                        [required]="false"
                        [readonly]="false"
                        [success]="isFieldValid(completeForm, 'employmentRelationshipClient')"
                        [error]="isFieldInvalid(completeForm, 'employmentRelationshipClient')"
                        [helper]="
                          (isFieldInvalid(completeForm, 'employmentRelationshipClient') ? 'FORMS.MANDATORY_FIELD' : '')
                            | translate
                        "
                      ></mfp-select>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="!lifePlan.user?.professional?.employment">
                  <div class="row">
                    <div class="col-xs-24 col-sm-12 col-no-gutter">
                      <mfp-select
                        formControlName="occupationClient"
                        view="agent"
                        color="primary"
                        name="occupationClient"
                        [label]="'COMPLETE_FORM.PROFESSIONAL.PROFESSIONALS_USER.OCCUPATION' | translate"
                        [placeholder]="'FORMS.SELECT_PLACEHOLDER' | translate"
                        [options]="occupation"
                        [required]="false"
                        [readonly]="false"
                        [success]="isFieldValid(completeForm, 'occupationClient')"
                        [error]="isFieldInvalid(completeForm, 'occupationClient')"
                        [helper]="
                          (isFieldInvalid(completeForm, 'occupationClient') ? 'FORMS.MANDATORY_FIELD' : '') | translate
                        "
                      ></mfp-select>
                    </div>
                  </div>
                </ng-container>
              </ng-container>

              <ng-container
                *ngIf="
                  hasSpouse() &&
                  (!lifePlan.spouse?.professional?.employmentRelationship ||
                    !lifePlan.spouse?.professional?.employment ||
                    !lifePlan.spouse?.professional?.contributionYears)
                "
              >
                <div class="agent-form__section"></div>
                <h3 class="agent-form__subtitle">
                  {{ 'COMPLETE_FORM.PROFESSIONAL.PROFESSIONALS_SPOUSE.TITLE' | translate }}
                </h3>
                <ng-container *ngIf="!lifePlan.spouse?.professional?.employmentRelationship">
                  <div class="row">
                    <div class="col-xs-24 col-sm-12 col-no-gutter">
                      <mfp-select
                        formControlName="employmentRelationshipSpouse"
                        view="agent"
                        color="primary"
                        name="employmentRelationshipSpouse"
                        [label]="'COMPLETE_FORM.PROFESSIONAL.PROFESSIONALS_SPOUSE.EMPLOYMENT_RELATIONSHIP' | translate"
                        [placeholder]="'FORMS.SELECT_PLACEHOLDER' | translate"
                        [options]="employmentRelationship"
                        [required]="false"
                        [readonly]="false"
                        [success]="isFieldValid(completeForm, 'employmentRelationshipSpouse')"
                        [error]="isFieldInvalid(completeForm, 'employmentRelationshipSpouse')"
                        [helper]="
                          (isFieldInvalid(completeForm, 'employmentRelationshipSpouse') ? 'FORMS.MANDATORY_FIELD' : '')
                            | translate
                        "
                      ></mfp-select>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="!lifePlan.spouse?.professional?.employment">
                  <div class="row">
                    <div class="col-xs-24 col-sm-12 col-no-gutter">
                      <mfp-select
                        formControlName="occupationSpouse"
                        view="agent"
                        color="primary"
                        name="occupationSpouse"
                        [label]="'COMPLETE_FORM.PROFESSIONAL.PROFESSIONALS_SPOUSE.OCCUPATION' | translate"
                        [placeholder]="'FORMS.SELECT_PLACEHOLDER' | translate"
                        [options]="occupation"
                        [required]="false"
                        [readonly]="false"
                        [success]="isFieldValid(completeForm, 'occupationSpouse')"
                        [error]="isFieldInvalid(completeForm, 'occupationSpouse')"
                        [helper]="
                          (isFieldInvalid(completeForm, 'occupationSpouse') ? 'FORMS.MANDATORY_FIELD' : '') | translate
                        "
                      ></mfp-select>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="!lifePlan.spouse?.professional?.contributionYears">
                  <div class="row row--no-margin">
                    <div class="col-xs-16 col-sm-6 col-no-gutter">
                      <mfp-input
                        formControlName="yearsWorkedSpouse"
                        view="agent"
                        [label]="'COMPLETE_FORM.PROFESSIONAL.PROFESSIONALS_SPOUSE.YEARS_WORKED' | translate"
                        name="yearsWorkedSpouse"
                        type="number"
                        [placeholder]="
                          'COMPLETE_FORM.PROFESSIONAL.PROFESSIONALS_SPOUSE.YEARS_WORKED_PLACEHOLDER' | translate
                        "
                        [required]="false"
                        [readonly]="false"
                        [success]="isFieldValid(completeForm, 'yearsWorkedSpouse')"
                        [error]="isFieldInvalid(completeForm, 'yearsWorkedSpouse')"
                        [helper]="
                          (isFieldInvalid(completeForm, 'yearsWorkedSpouse') ? 'FORMS.MANDATORY_FIELD' : '') | translate:{min: minContributionYears, max: maxContributionYears}
                        "
                      ></mfp-input>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </ng-container>

          <ng-container
            *ngIf="
              ((type === 'FINANCIAL_INFORMATION' || type === 'DEATH') &&
                (!lifePlan.user?.financial?.loans || (hasSpouse() && !lifePlan.spouse?.financial?.netMonthlyIncome))) ||
              (type === 'RETIREMENT' &&
                (!lifePlan.user?.financial?.investorProfile || !lifePlan.user?.financial?.futurePlans)) ||
              (type === 'SAVING' &&
                (!lifePlan.user?.financial?.investorProfile ||
                  !lifePlan.user?.financial?.futurePlans ||
                  (hasSpouse() && !lifePlan.spouse?.financial?.netMonthlyIncome)))
            "
          >
            <div class="financial-form">
              <h2 class="agent-form__title">{{ 'COMPLETE_FORM.FINANCIAL.TITLE' | translate }}</h2>
              <ng-container *ngIf="hasSpouse() && !lifePlan.spouse?.financial?.netMonthlyIncome">
                <div class="agent-form__section"></div>
                <h3 class="agent-form__subtitle">{{ 'COMPLETE_FORM.FINANCIAL.INCOME.TITLE' | translate }}</h3>
                <div class="row">
                  <div class="col-xs-24 col-sm-9 col-no-gutter">
                    <mfp-input-currency
                      view="agent"
                      name="spouseNetMonthlyIncome"
                      formControlName="spouseNetMonthlyIncome"
                      [label]="'COMPLETE_FORM.FINANCIAL.INCOME.SPOUSE_NET_MONTHLY_INCOME' | translate"
                      [currencyOptions]="currencyOptions"
                      [required]="false"
                      [readonly]="false"
                      [success]="isFieldValid(completeForm, 'spouseNetMonthlyIncome')"
                      [error]="isFieldInvalid(completeForm, 'spouseNetMonthlyIncome')"
                      [helper]="
                        (isFieldInvalid(completeForm, 'spouseNetMonthlyIncome') ? 'FORMS.MANDATORY_FIELD' : '')
                          | translate
                      "
                    ></mfp-input-currency>
                  </div>
                </div>
              </ng-container>

              <ng-container
                *ngIf="
                  (type === 'SAVING' || type === 'RETIREMENT') &&
                  (!lifePlan.user?.financial?.investorProfile || !lifePlan.user?.financial?.futurePlans)
                "
              >
                <div class="agent-form__section"></div>
                <h3 class="agent-form__subtitle">{{ 'COMPLETE_FORM.FINANCIAL.FUTURE_PLANS.TITLE' | translate }}</h3>
                <ng-container *ngIf="!lifePlan.user?.financial?.investorProfile">
                  <div class="row">
                    <div class="col-xs-24 col-sm-12 col-no-gutter">
                      <mfp-select
                        name="investorProfile"
                        formControlName="investorProfile"
                        view="agent"
                        [label]="'COMPLETE_FORM.FINANCIAL.FUTURE_PLANS.INVESTOR_PROFILE' | translate"
                        [placeholder]="'FORMS.SELECT_PLACEHOLDER' | translate"
                        [options]="investorProfileOptions"
                        [success]="isFieldValid(completeForm, 'investorProfile')"
                        [error]="isFieldInvalid(completeForm, 'investorProfile')"
                      ></mfp-select>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="!lifePlan.user?.financial?.futurePlans">
                  <div class="row">
                    <div class="col-xs-24 col-no-gutter">
                      <mfp-checkbox
                        name="hasFuturePlans"
                        formControlName="hasFuturePlans"
                        view="agent"
                        [label]="'COMPLETE_FORM.FINANCIAL.FUTURE_PLANS.HAS_FUTURE_PLANS' | translate"
                      ></mfp-checkbox>
                    </div>
                  </div>
                  <ng-container *ngIf="completeForm.controls.hasFuturePlans.value">
                    <div class="row">
                      <div class="col-xs-offset-2 col-xs-22 col-sm-offset-1 col-sm-23 col-no-gutter">
                        <mfp-dynamic-list
                          name="futurePlans"
                          [formArray]="futurePlansFormArray"
                          [createControl]="createFuturePlansDefaultValue"
                          [addButtonLabel]="'COMPLETE_FORM.FINANCIAL.FUTURE_PLANS.ITEM.ADD' | translate"
                        >
                          <ng-template let-formControl="formControl" let-index="index" let-removeItem="removeItem">
                            <mfp-future-plan
                              view="agent"
                              goalTypeName="type"
                              goalAmountName="goalAmount"
                              assuredAmountName="assuredAmount"
                              dateName="goalDate"
                              [form]="formControl"
                              [label]="'COMPLETE_FORM.FINANCIAL.FUTURE_PLANS.ITEM.TITLE' | translate: { i: index + 1 }"
                              [goalTypeLabel]="'COMPLETE_FORM.FINANCIAL.FUTURE_PLANS.ITEM.TYPE' | translate"
                              [goalTypePlaceholder]="'FORMS.SELECT_PLACEHOLDER' | translate"
                              [goalAmountLabel]="'COMPLETE_FORM.FINANCIAL.FUTURE_PLANS.ITEM.GOAL_AMOUNT' | translate"
                              [assuredAmountLabel]="
                                'COMPLETE_FORM.FINANCIAL.FUTURE_PLANS.ITEM.ASSURED_AMOUNT' | translate
                              "
                              [dateLabel]="'COMPLETE_FORM.FINANCIAL.FUTURE_PLANS.ITEM.YEAR' | translate"
                              [datePlaceholder]="
                                'COMPLETE_FORM.FINANCIAL.FUTURE_PLANS.ITEM.YEAR_PLACEHOLDER' | translate
                              "
                              [dateErrorData]="goalYearsLimit"
                              [removeLabel]="'COMPLETE_FORM.FINANCIAL.FUTURE_PLANS.ITEM.DELETE' | translate"
                              [currencyOptions]="currencyOptions"
                              [goalTypeOptions]="futurePlansOptions"
                              (removeItem)="removeItem()"
                            ></mfp-future-plan>
                          </ng-template>
                        </mfp-dynamic-list>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="!lifePlan.user?.financial?.loans">
                <div class="agent-form__section"></div>
                <h3 class="agent-form__subtitle">{{ 'COMPLETE_FORM.FINANCIAL.LOANS.TITLE' | translate }}</h3>
                <div class="row">
                  <div class="col-xs-24 col-no-gutter">
                    <mfp-checkbox
                      name="hasLoans"
                      formControlName="hasLoans"
                      view="agent"
                      [label]="'COMPLETE_FORM.FINANCIAL.LOANS.HAS_LOANS' | translate"
                    ></mfp-checkbox>
                  </div>
                </div>
                <ng-container *ngIf="completeForm.controls.hasLoans.value">
                  <div class="row">
                    <div class="col-xs-offset-2 col-xs-22 col-sm-offset-1 col-sm-23 col-no-gutter">
                      <mfp-dynamic-list
                        name="loans"
                        [formArray]="loansFormArray"
                        [createControl]="createLoansDefaultValue"
                        [addButtonLabel]="'COMPLETE_FORM.FINANCIAL.LOANS.ITEM.ADD' | translate"
                      >
                        <ng-template let-formControl="formControl" let-index="index" let-removeItem="removeItem">
                          <mfp-loan
                            view="agent"
                            loanTypeName="type"
                            pendingAmountName="pendingAmount"
                            monthlyFeeName="monthlyFee"
                            remainingYearsName="remainingYears"
                            [form]="formControl"
                            [label]="'COMPLETE_FORM.FINANCIAL.LOANS.ITEM.TITLE' | translate: { i: index + 1 }"
                            [loanTypeLabel]="'COMPLETE_FORM.FINANCIAL.LOANS.ITEM.TYPE' | translate"
                            [loanTypePlaceholder]="'FORMS.SELECT_PLACEHOLDER' | translate"
                            [pendingAmountLabel]="'COMPLETE_FORM.FINANCIAL.LOANS.ITEM.PENDING_AMOUNT' | translate"
                            [monthlyFeeLabel]="'COMPLETE_FORM.FINANCIAL.LOANS.ITEM.MONTHLY_FEE' | translate"
                            [remainingYearsLabel]="'COMPLETE_FORM.FINANCIAL.LOANS.ITEM.REMAINING_YEARS' | translate"
                            [remainingYearsPlaceholder]="
                              'COMPLETE_FORM.FINANCIAL.LOANS.ITEM.REMAINING_YEARS_PLACEHOLDER' | translate
                            "
                            [removeLabel]="'COMPLETE_FORM.FINANCIAL.LOANS.ITEM.DELETE' | translate"
                            [currencyOptions]="currencyOptions"
                            [loanTypeOptions]="loansOptions"
                            (removeItem)="removeItem()"
                          ></mfp-loan>
                        </ng-template>
                      </mfp-dynamic-list>
                    </div>
                  </div> </ng-container
              ></ng-container>
            </div>
          </ng-container>

          <ng-container
            *ngIf="
              (type === 'DEATH' || type === 'RETIREMENT') &&
              (!lifePlan.user?.insurances || (hasSpouse() && !lifePlan.spouse?.insurances))
            "
          >
            <div class="insurance-form">
              <h2 class="agent-form__title">{{ 'COMPLETE_FORM.INSURANCE.TITLE' | translate }}</h2>
              <ng-container *ngIf="type === 'DEATH' && !lifePlan.user?.insurances">
                <div class="agent-form__section"></div>
                <h3 class="agent-form__subtitle">
                  {{ 'COMPLETE_FORM.INSURANCE.USER.TITLE' | translate: { username: getUsername() } }}
                </h3>
                <div class="row">
                  <div class="col-xs-24 col-no-gutter">
                    <mfp-checkbox
                      name="hasDeathInsurance"
                      formControlName="hasDeathInsurance"
                      view="agent"
                      [label]="'COMPLETE_FORM.INSURANCE.USER.DEATH_INSURANCE' | translate"
                    ></mfp-checkbox>
                  </div>
                </div>
                <ng-container *ngIf="completeForm.value.hasDeathInsurance">
                  <div class="row">
                    <div
                      class="col-xs-offset-2 col-xs-22 col-xs--no-padding-right col-sm-offset-1 col-sm-9 col-gutter-lr"
                    >
                      <mfp-input-currency
                        view="agent"
                        [label]="'COMPLETE_FORM.INSURANCE.ASSURED_AMOUNT' | translate"
                        name="deathInsuranceAssuredAmount"
                        formControlName="deathInsuranceAssuredAmount"
                        type="text"
                        [currencyOptions]="currencyOptions"
                        [required]="false"
                        [readonly]="false"
                        [success]="isFieldValid(completeForm, 'deathInsuranceAssuredAmount')"
                        [error]="isFieldInvalid(completeForm, 'deathInsuranceAssuredAmount')"
                        [helper]="
                          (isFieldInvalid(completeForm, 'deathInsuranceAssuredAmount') ? 'FORMS.MANDATORY_FIELD' : '')
                            | translate
                        "
                      ></mfp-input-currency>
                    </div>
                    <div
                      class="col-xs-offset-2 col-xs-22 col-xs--no-padding-left col-xs--margin-top col-sm-9 col-gutter-lr"
                    >
                      <mfp-input-currency
                        view="agent"
                        [label]="'COMPLETE_FORM.INSURANCE.MONTHLY_FEE' | translate"
                        name="deathInsuranceMonthlyFee"
                        formControlName="deathInsuranceMonthlyFee"
                        type="text"
                        [currencyOptions]="currencyOptions"
                        [required]="false"
                        [readonly]="false"
                        [success]="isOptionalFieldSuccessWhenComplete(completeForm, 'deathInsuranceMonthlyFee')"
                        [error]="isFieldInvalid(completeForm, 'deathInsuranceMonthlyFee')"
                        [helper]="
                          (isFieldInvalid(completeForm, 'deathInsuranceMonthlyFee') ? 'FORMS.FIELD_NOT_VALID' : '')
                            | translate
                        "
                      ></mfp-input-currency>
                    </div>
                  </div>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="type === 'DEATH' && hasSpouse() && !lifePlan.spouse?.insurances">
                <div class="agent-form__section"></div>
                <h3 class="agent-form__subtitle">{{ 'COMPLETE_FORM.INSURANCE.SPOUSE.TITLE' | translate }}</h3>
                <div class="row">
                  <div class="col-sm-24 col-no-gutter">
                    <mfp-checkbox
                      name="hasSpouseDeathInsurance"
                      formControlName="hasSpouseDeathInsurance"
                      view="agent"
                      [label]="'COMPLETE_FORM.INSURANCE.SPOUSE.DEATH_INSURANCE' | translate"
                    ></mfp-checkbox>
                  </div>
                </div>
                <ng-container *ngIf="completeForm.value.hasSpouseDeathInsurance">
                  <div class="row">
                    <div
                      class="col-xs-offset-2 col-xs-22 col-xs--no-padding-right col-sm-offset-1 col-sm-9 col-gutter-lr"
                    >
                      <mfp-input-currency
                        view="agent"
                        [label]="'COMPLETE_FORM.INSURANCE.ASSURED_AMOUNT' | translate"
                        name="spouseDeathInsuranceAssuredAmount"
                        formControlName="spouseDeathInsuranceAssuredAmount"
                        type="text"
                        [currencyOptions]="currencyOptions"
                        [required]="false"
                        [readonly]="false"
                        [success]="isFieldValid(completeForm, 'spouseDeathInsuranceAssuredAmount')"
                        [error]="isFieldInvalid(completeForm, 'spouseDeathInsuranceAssuredAmount')"
                        [helper]="
                          (isFieldInvalid(completeForm, 'spouseDeathInsuranceAssuredAmount')
                            ? 'FORMS.MANDATORY_FIELD'
                            : ''
                          ) | translate
                        "
                      ></mfp-input-currency>
                    </div>
                    <div
                      class="col-xs-offset-2 col-xs-22 col-xs--no-padding-left col-xs--margin-top col-sm-9 col-gutter-lr"
                    >
                      <mfp-input-currency
                        view="agent"
                        [label]="'COMPLETE_FORM.INSURANCE.MONTHLY_FEE' | translate"
                        name="spouseDeathInsuranceMonthlyFee"
                        formControlName="spouseDeathInsuranceMonthlyFee"
                        type="text"
                        [currencyOptions]="currencyOptions"
                        [required]="false"
                        [readonly]="false"
                        [success]="isOptionalFieldSuccessWhenComplete(completeForm, 'spouseDeathInsuranceMonthlyFee')"
                        [error]="isFieldInvalid(completeForm, 'spouseDeathInsuranceMonthlyFee')"
                        [helper]="
                          (isFieldInvalid(completeForm, 'spouseDeathInsuranceMonthlyFee')
                            ? 'FORMS.FIELD_NOT_VALID'
                            : ''
                          ) | translate
                        "
                      ></mfp-input-currency>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </ng-container>
        </div>
        <div class="complete-form__actions">
          <mfp-button
            type="button"
            color="primary"
            fill="outline"
            [label]="'CANCEL' | translate"
            (click)="close()"
          ></mfp-button>
          <mfp-button
            class="complete-form__actions-save"
            type="submit"
            color="primary"
            fill="default"
            [label]="'SAVE' | translate"
          ></mfp-button>
        </div>
      </div>
    </form>
  </div>
</div>
